import { Tag, Typography } from 'antd';
import React, { memo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DeliveryStatus } from '../../api/models/deliveries';
import styles from './OrderStatus.module.less';
import * as PropTypes from 'prop-types';

const orderStatusMapper = {
  [DeliveryStatus.Pending]: 'deliveries.deliveryStatus.pending',
  [DeliveryStatus.Assigned]: 'deliveries.deliveryStatus.assigned',
  [DeliveryStatus.AtPickup]: 'deliveries.deliveryStatus.arrived',
  [DeliveryStatus.InProgress]: 'deliveries.deliveryStatus.inProgress',
  [DeliveryStatus.Delivered]: 'deliveries.deliveryStatus.delivered',
  [DeliveryStatus.Cancelled]: 'deliveries.deliveryStatus.cancelled',
  [DeliveryStatus.CNF]: 'deliveries.deliveryStatus.CNF'
};

const OrderStatus = props => {
  const { status, className } = props;
  const { t } = useTranslation();

  return (
    <Tag className={classnames(styles.status, styles[status], className)}>
      <Typography.Text strong className={styles.status}>
        {t(orderStatusMapper[status])}
      </Typography.Text>
    </Tag>
  );
};

OrderStatus.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default memo(OrderStatus);
